import { PackStatusDto } from '../../dto/packstatus/packstatusdto';
import { APIRequest, APIRequestDtoImpl } from '../apiRequest';

export interface PackStatusRequest extends APIRequest
{
    getPackStatusRequest(): PackStatusDto;
}

export class PackStatusRequestImpl extends APIRequestDtoImpl implements PackStatusRequest
{
    constructor(private packStatusData: PackStatusDto)
    {
        super();
    }

    getPackStatusRequest(): PackStatusDto
    {
        return this.packStatusData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/packstatus/packstatusrequest.tsx